import { useState, FormEvent } from "react";

interface ForgotPasswordViewProps {
  setView: (view: string) => void;
}


//TODO
const ForgotPasswordView = ({ setView }: ForgotPasswordViewProps) => {
  const [requestSent, setRequestSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setRequestSent(true);
    setSubmitting(false);
    setError("");
    /*const formData = new FormData(e.target as HTMLFormElement);
    setError("");
    const username = formData.get("username") as string;
    if (!username) {
      setError("Email is required.");
      return;
    }
    setSubmitting(true);
    try {
      const result = await authAPI.sendPasswordRecoveryLink(username);
      if (result.success) {
        setRequestSent(true);
      } else {
        setError(result.error || "An error occurred.");
      }
    } catch (err: any) {
      setError(err.error || err.message || "An error occurred.");
    } finally {
      setSubmitting(false);
    }*/
  };

  return (
    <form className="w-full" onSubmit={handleSubmit}>
      <h1 className="text-2xl px-5 full-width text-center">Password Recovery</h1>
      {requestSent ? (
        <div className="text-center">
          <div className="py-2">
            {/* Replace with SuccessAnimatedIcon */}
          </div>
          <div className="flex py-1 px-4 my-2 text-xs bg-green-100 text-green-700 rounded h-20 items-center">
            Check your email for further instructions.
          </div>
        </div>
      ) : (
        <>
          <div className="flex justify-center pb-2">Enter your email to recover your password.</div>
          {error && <div className="py-1 px-4 my-2 text-xs bg-red-100 text-red-700 rounded">{error}</div>}
          <input
            placeholder="Enter your email"
            id="username"
            name="username"
            type="email"
            disabled={submitting}
            className="my-3 w-full p-2 border border-gray-300 rounded-md dark:bg-gray-900"
          />
          <button type="submit" disabled={submitting} className="w-full bg-blue-600 text-white rounded-md text-sm h-10 mt-5">
            Send Reset Link
          </button>
        </>
      )}
      <div className="flex flex-row justify-end pt-2">
        <button className="text-sm text-gray-600 cursor-pointer hover:underline" onClick={() => setView("login")} disabled={submitting}>
          Back to Login
        </button>
      </div>
    </form>
  );
};

export default ForgotPasswordView;
